import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
}), 'FormatSizeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatSizeSharp.js
// module id = 3892
// module chunks = 2